import ExportFile from '#/components/ExportFile'
import { useAttachmentDownload } from '#/components/FormatCell/Types/attachments/Logic'
import { TypeAttachmentsProps } from '#/components/FormatCell/Types/attachments/types'
import { AttachmentsIcon } from '#/components/FormatCell/Types/attachments/View/icon'
import { AttachmentsIconText } from '#/components/FormatCell/Types/attachments/View/iconText'

export function TypeAttachments({ value, variant = 'icon' }: TypeAttachmentsProps) {
  const { closeExport, fileController, handleClick } = useAttachmentDownload(value)

  if (!value?.url) {
    return '-'
  }

  const AttachmentsVariant = variant === 'icon-text' ? AttachmentsIconText : AttachmentsIcon

  return (
    <>
      <AttachmentsVariant filename={value.filename} onClick={handleClick} />
      {fileController && (
        <ExportFile controller={fileController} onCloseModal={closeExport} modalOpen />
      )}
    </>
  )
}
